require('./dialog2/view.js');
require('./dialog2/footer-rendering.js');

